import "./FirePumpsHeatExchangers.module.css";
import Header from "@/reusable_sections/Header";
import CommercialHero from "./sections/CommercialHero";
import Services from "./sections/Services";
import Areas from "./sections/Areas";
import Quote from "./sections/Quote";
import Completedservicesgallery from "./sections/Completedservicesgallery";
import Footer from "@/reusable_sections/Footer";
export default function FirePumpsHeatExchangersPage() {
  return <div>
      <Header />
      <CommercialHero />
      <Services />
      <Areas />
      <Completedservicesgallery />
      <Quote />
      
      <Footer />
    </div>;
}